import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Page, Breadcrumb, ResponseDialog } from '../../components';
import { Input, Spin } from 'antd';
import MenuCategoryBuilderActions from '../../redux/middleware/menuCategoryBuilder';
import './menuCategoryBuilderWizard.scss';
import Utils from '../../redux/utils';

const menuCategoryBuilderWizard = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { update, id } = state;
  // eslint-disable-next-line no-unused-vars
  const [errorList, setErrorList] = React.useState<any>({});
  // eslint-disable-next-line no-unused-vars
  const [errorStatus, setErrorStatus] = React.useState(false);
  const [apiLoader, setApiLoader] = React.useState(false);
  const [menuCategory, setMenuCategory] = React.useState('');
  const fetchDataById = async (id: any) => {
    const data = await MenuCategoryBuilderActions.getMenuCategoryByIdBuilder(
      id
    );
    if (data) {
      setApiLoader(false);
    }
    setMenuCategory(data?.data?.category_name);
  };

  useEffect(() => {
    if (update) {
      setApiLoader(true);
      fetchDataById(id);
    }
  }, []);

  const handleMenuCategory = (data: string) => {
    setMenuCategory(data);
  };

  const handleContinue = async () => {
    const company = await Utils.getCurrentCompany();
    const brand = await Utils.getCurrentBrand();

    const param = {
      company_id: company?.id,
      category_name: menuCategory,
      brand_id: brand?.brand_id,
    };

    try {
      let responseDialogData;
      setApiLoader(true);
      let response;
      if (update) {
        response = await MenuCategoryBuilderActions.updateMenuCategoryBuilder(
          id,
          param
        );
      } else {
        response = await MenuCategoryBuilderActions.addMenuCategoryBuilder(
          param
        );
      }
      setApiLoader(false);
      if (!response?.success) {
        setErrorList(response?.error);
        setErrorStatus(true);
        responseDialogData = {
          OnClick: () => {},
          type: 'error',
          messageArray: ['Validation Failed!', 'Something Went Wrong'],
        };
        ResponseDialog(responseDialogData);
      } else {
        responseDialogData = {
          OnClick: () => {
            navigate('/app/rd-menuCategory');
          },
          type: 'success',
          messageArray: [
            ` Your ${menuCategory} Ingredient`,
            ` has been ${!update ? 'Created' : 'Updated'}`,
          ],
        };
        ResponseDialog(responseDialogData);
      }
    } catch (e) {
      console.log(e);
      let responseDialogData = {
        OnClick: () => {},
        type: 'error',
        messageArray: ['Server Error!', 'Something Went Wrong'],
      };
      ResponseDialog(responseDialogData);
    }
  };

  return (
    <React.Fragment>
      <Breadcrumb
        heading="Add New Menu Category"
        breadcrumbIcon
        iconAction={() => {
          navigate('/app/rd-menuCategory');
        }}
      />

      <Spin
        size="large"
        className="loadIngredient recipeBuilderloaderHeight"
        spinning={apiLoader}
      >
        <Page title="Add New Menu Category">
          {/* <div className="alertMessage">
          {visible && (
            <Alert
              message="Error"
              description="Please Complete required fields!"
              type="error"
              showIcon
              closable
              className="wizardAlert"
              afterClose={() => setVisible(false)}
            />
          )}

          {error &&
            errorMessage?.map((data: any, index: any) => (
              <Alert
                message="Error"
                description={data}
                type="error"
                showIcon
                closable
                className="wizardAlert"
                afterClose={() => setError(false)}
                key={index}
              />
            ))}
        </div> */}
          <div className="wizardContainer">
            <div className="ingredientCategoryContainerWidth">
              <div className="wizardSubContainer wrapper">
                <div className="wizardLabel">
                  Menu Category Name <span className="sterik">*</span>
                </div>
                <Input
                  placeholder="Enter Menu Category Name"
                  size="large"
                  value={menuCategory}
                  onChange={(e) => {
                    handleMenuCategory(e.target.value);
                  }}
                  required
                />
              </div>
            </div>
            <div className="butonGroup">
              <div className="wizard-button" onClick={() => handleContinue()}>
                Back
              </div>
              <div className="continue wizard-button" onClick={handleContinue}>
                Continue
              </div>
            </div>
          </div>
        </Page>
      </Spin>
    </React.Fragment>
  );
};

export default menuCategoryBuilderWizard;
